import React, { useState } from 'react';
import SortableList, { SortableItem } from "react-easy-sort";
import ActionComponent from '../../pages/Activity/Component/ActionComponent';
import './List.css';

const List = ({ items, enableCustom = false, callSort }) => {
    // State to manage the dragging state
    const [isSortableEnabled, setIsSortableEnabled] = useState(enableCustom);

    const toggleSortable = () => {
        setIsSortableEnabled(!isSortableEnabled);
    };

    return (
        <div className='p-3'>
            {/* Switch Button to toggle dragging */}
            {enableCustom && (<div className="sortable-toggle">
                <label>
                    Enable Sorting:
                    <input
                        type="checkbox"
                        checked={isSortableEnabled}
                        onChange={toggleSortable}
                    />
                </label>
            </div>)}

            {/* Sortable List */}
            <SortableList
                allowDrag={isSortableEnabled}
                onSortEnd={callSort}
                className="list"
                draggedItemClassName="dragged"
            >
                {items.map((action, index) => (
                    <SortableItem key={action.id} index={index}>
                        <div >
                            <ActionComponent
                                key={index}
                                action={action}
                                custom={enableCustom}
                            />
                        </div>
                    </SortableItem>
                ))}
            </SortableList>
        </div>
    );
};

export default List;
